const types = {
  //Get Request List
  GET_LOG_START: "GET_LOG_START",
  GET_LOG_SUCCESS: "GET_LOG_SUCCESS",
  GET_LOG_ERROR: "GET_LOG_ERROR",
  GET_LOG_RESET: "GET_LOG_RESET",

  //Create Request
  CREATE_LOG_START: "CREATE_LOG_START",
  CREATE_LOG_SUCCESS: "CREATE_LOG_SUCCESS",
  CREATE_LOG_ERROR: "CREATE_LOG_ERROR",
  CREATE_LOG_RESET: "CREATE_LOG_RESET",

  //Update Request
  UPDATE_LOG_START: "UPDATE_LOG_START",
  UPDATE_LOG_SUCCESS: "UPDATE_LOG_SUCCESS",
  UPDATE_LOG_ERROR: "UPDATE_LOG_ERROR",
  UPDATE_LOG_RESET: "UPDATE_LOG_RESET",

  //Delete Request
  DELETE_LOG_START: "DELETE_LOG_START",
  DELETE_LOG_SUCCESS: "DELETE_LOG_SUCCESS",
  DELETE_LOG_ERROR: "DELETE_LOG_ERROR",
  DELETE_LOG_RESET: "DELETE_LOG_RESET",

  //Single Request
  SINGLE_LOG_START: "SINGLE_LOG_START",
  SINGLE_LOG_SUCCESS: "SINGLE_LOG_SUCCESS",
  SINGLE_LOG_ERROR: "SINGLE_LOG_ERROR",
  SINGLE_LOG_RESET: "SINGLE_LOG_RESET",
};

export default types;

